export default "__VITE_ASSET__CyU869OG__"